import api from '@/api';
import { API_BASE_URL } from '..';
import {
  FragaProductRequest,
  FragaProductByPlateRequest,
  FragaProductByPlateResponse,
  FragaProductResponse,
} from './Fraga.types';

const CONTROLLER = `${API_BASE_URL}/fraga`;

export default {
  async productsByPlate(params?: FragaProductByPlateRequest) {
    const result = (await api.get(`${CONTROLLER}/plate`, params)) as unknown;
    return result as FragaProductByPlateResponse;
  },

  async products(params?: FragaProductRequest) {
    const result = (await api.get(`${CONTROLLER}/products`, params)) as unknown;
    return result as FragaProductResponse;
  },
};
